/**
 * Copyright 2020-present, TIENDUC.
 * All rights reserved.
 * @author ductt24@ghtk.vn on 11/08/2020.
 * @module IDENTITY SAGA
 */

import {
  setAuthenticated,
  getMe,
  logout} from "./actions";
import { call, put, takeLatest } from "redux-saga/effects";
import _ from "lodash";
import cookie from "lib/cookie";
import services from "services";
import AppConfiguration from "dataProvider/config";
import { GhtkAuth } from "lib/gmjs";
import { USER_PERMISSION } from "app/ultils/constant";

function getMeRequest() {
  return services.IOT.getMe();
}

const _handleGetMe = function*() {
  try {
    yield put(getMe.request());
    let response = yield call(getMeRequest);
    if (response.success) {
      let user = response.data.user;
      let menus = response.data.menus;

      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("menus", JSON.stringify(menus));
      let isAdmin = user.roles.includes(USER_PERMISSION.SUPER_WRITE);

      yield put(setAuthenticated({ isAuthenticated: true, user, isAdmin }));
    }
  } catch (error) {
    yield put(getMe.failure({ error }));
  } finally {
    yield put(getMe.fulfill());
  }
};

let delete_cookie = function(name) {
  document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
};
const _handleLogout = function*() {
  try {
    localStorage.removeItem("p_sid");
    localStorage.removeItem("user");
    localStorage.removeItem("menus");
    // remove our token
    cookie.remove("token");
    cookie.remove("user_id");
    cookie.remove("province_id");
    cookie.remove("PHPSESSID");
    delete_cookie("PHPSESSID");
    delete_cookie("token");
    delete_cookie("user_id");
    delete_cookie("province_id");
    delete_cookie("group_id");
    yield put(
      setAuthenticated({ user: null, isAuthenticated: false, menu: null })
    );
    let ghtkAuth = new GhtkAuth(AppConfiguration.ghtkID.oidc);
    ghtkAuth
      .signOut({
        revokeAccessToken: true,
        postLogoutRedirectUri: `${
          AppConfiguration.ghtkID.oidc.authnUrl
        }/sign-out?continue=${AppConfiguration.ghtkID.oidc.logoutBackUrl}`
      })
      .catch(() => {
        window.location = `${
          AppConfiguration.ghtkID.oidc.authnUrl
        }/sign-out?continue=${AppConfiguration.ghtkID.oidc.logoutBackUrl}`;
      });
  } catch (error) {
    window.location = `${AppConfiguration.ghtkID.oidc.authnUrl}/sign-out`;
  }
};

export default function* saga() {
  yield takeLatest(logout.TRIGGER, _handleLogout);
  yield takeLatest(getMe.TRIGGER, _handleGetMe);
}
